import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  LabelledText
} from 'modules';

import { Grid } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  return (
    <BaseWidget.FC title="Reported Device Issue">
      <Grid container>
        <Grid
          item
          xs={6}>
          {_.map(queryTuple.data.returnAuthorization?.problemStatements ?? [], (problem, index) => (
            <LabelledText.FC
              key={index}
              title={`Problem ${index + 1}`}
              text={problem} />
          ))}
        </Grid>

        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Customer Comments"
            text={queryTuple.data.returnAuthorization?.customerComments} />
        </Grid>
      </Grid>
    </BaseWidget.FC>
  );
};
